module.exports = __webpack_public_path__ + "img/certificate-EC-4.5-5.5.b59f5599.jpg";